import React, { useEffect, useState } from 'react';
import { FaPlay } from 'react-icons/fa6';
import { fetchJSON } from '../lib/api';

const STREAM_HOST = 'iframe.cloudflarestream.com';

export default function VideoPlayer({ lessonId }) {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    fetchJSON(`/api/media/video/${lessonId}`)
      .then((data) => {
        if (alive) setConfig(data);
      })
      .catch((err) => {
        if (alive) setError(err.message);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [lessonId]);

  if (loading || error || !config) {
    return (
      <div className="aspect-video rounded-2xl overflow-hidden bg-ink text-bone flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-deep via-ink to-brand-aubergine/70 opacity-90 pointer-events-none" />
        <div className="relative text-center px-6">
          {error ? (
            <>
              <div className="text-[11px] tracking-[0.18em] uppercase text-brand-sage">
                Video unavailable
              </div>
              <p className="mt-2 text-sm text-bone/70 max-w-sm mx-auto">{error}</p>
            </>
          ) : (
            <>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-bone/15 backdrop-blur border border-bone/20">
                <FaPlay className="text-bone text-xl translate-x-0.5 animate-pulse" />
              </div>
              <div className="mt-4 text-sm text-bone/70">Loading video…</div>
            </>
          )}
        </div>
      </div>
    );
  }

  const idOrToken = config.signed ? config.token : config.uid;
  const src = `https://${STREAM_HOST}/${idOrToken}`;

  return (
    <div className="aspect-video rounded-2xl overflow-hidden bg-ink shadow-md">
      <iframe
        src={src}
        title="Lesson video"
        className="w-full h-full block"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen
      />
    </div>
  );
}
